// import level_zs from "@/assets/home/level_zs.png";
// import level_hg from "@/assets/home/level_hg.png";
// import level_ty from "@/assets/home/level_ty.png";
// import level_pt from '@/assets/home/level_pt.png';
// //获取会员等级
// export function get_member_lvl(val) {
//     const lvl_arr = ['普通会员','黄金会员','铂金会员','砖石会员'];
//     return lvl_arr[val * 1];
// }

// export function set_lvl(item) {
//     if (item.point_level == 0) {
//         item.icon = level_pt;
//         item.img_len = 1;
//     } else if (item.point_level < 4) {
//         item.icon = level_zs;
//         item.img_len = item.point_level;
//     } else if (item.point_level >= 4 && item.point_level <= 6) {
//         item.icon = level_hg;
//         item.img_len = item.point_level - 3;
//     } else {
//         item.icon = level_ty;
//         item.img_len = item.point_level - 6;
//     }
//     return item;
// }

/**
 * 格式化UTC时间为指定时区的本地时间字符串
 * @param {string} utcTimeString - UTC时间字符串，如 "2025-11-21T22:10:08.000Z"
 * @param {string|number} timeZoneOffset - 时区偏移量（小时），默认为 8 (东八区)
 * @param {string} format - 格式化格式，默认为 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的时间字符串
 */
export function formatUTCTime(utcTimeString, timeZoneOffset = 8, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!utcTimeString) {
        return '';
    }
    
    try {
        let date;
        
        // 检查字符串是否已经是标准UTC格式（有Z或+00:00）
        if (utcTimeString.includes('Z') || utcTimeString.includes('+00:00') || utcTimeString.includes('-00:00')) {
            // 标准UTC格式，直接解析
            date = new Date(utcTimeString);
        } else {
            // 没有时区标识，当作UTC时间处理
            // 将格式如 "2025-11-22 07:41:00" 转换为 "2025-11-22T07:41:00Z"
            let utcStr = utcTimeString.trim();
            // 如果包含空格，替换为T并添加Z
            if (utcStr.includes(' ')) {
                utcStr = utcStr.replace(' ', 'T');
            }
            // 如果没有Z或时区标识，添加Z表示UTC
            if (!utcStr.includes('Z') && !utcStr.includes('+') && !utcStr.includes('-', 10)) {
                utcStr += 'Z';
            }
            date = new Date(utcStr);
        }
        
        // 如果日期无效，返回空字符串
        if (isNaN(date.getTime())) {
            return '';
        }
        
        // 获取UTC时间的各个部分（使用getUTC*方法确保获取的是UTC时间）
        let year = date.getUTCFullYear();
        let month = date.getUTCMonth() + 1;
        let day = date.getUTCDate();
        let hours = date.getUTCHours();
        let minutes = date.getUTCMinutes();
        let seconds = date.getUTCSeconds();
        
        // 加上时区偏移（小时）
        hours += timeZoneOffset;
        
        // 处理跨天、跨月、跨年的情况
        if (hours >= 24) {
            hours -= 24;
            day += 1;
            // 检查是否需要跨月
            const daysInMonth = new Date(year, month, 0).getDate();
            if (day > daysInMonth) {
                day = 1;
                month += 1;
                // 检查是否需要跨年
                if (month > 12) {
                    month = 1;
                    year += 1;
                }
            }
        } else if (hours < 0) {
            hours += 24;
            day -= 1;
            // 检查是否需要跨月
            if (day < 1) {
                month -= 1;
                if (month < 1) {
                    month = 12;
                    year -= 1;
                }
                day = new Date(year, month, 0).getDate();
            }
        }
        
        // 格式化为字符串
        const monthStr = String(month).padStart(2, '0');
        const dayStr = String(day).padStart(2, '0');
        const hoursStr = String(hours).padStart(2, '0');
        const minutesStr = String(minutes).padStart(2, '0');
        const secondsStr = String(seconds).padStart(2, '0');
        
        // 根据格式返回
        return format
            .replace('YYYY', year)
            .replace('MM', monthStr)
            .replace('DD', dayStr)
            .replace('HH', hoursStr)
            .replace('mm', minutesStr)
            .replace('ss', secondsStr);
    } catch (error) {
        console.error('时间格式化错误:', error);
        return '';
    }
} 


// WEBPACK FOOTER //
// ./src/common/common.js